import "./index.scss";
import axios from "axios";
import moment from "moment";
import {
  Icon, Divider, Segment, Container, Grid, GridColumn, Header,
  TableRow,
  TableHeaderCell,
  TableHeader,
  TableCell,
  TableBody,
  Table, GridRow, Search, Button, Label, Input
} from 'semantic-ui-react'
import { useState, useEffect } from 'react'
import ExcelJS from 'exceljs'
import React from "react";


function Reports() {

  const options = [
    { key: '', value: 'Todos', text: 'Todos' },
    { key: 'nome', value: 'Nome', text: 'Nome' },
    { key: 'corporate_name', value: 'Nome da Empresa', text: 'Nome da Empresa' },
  ]
  // const [sent, setSent] = useState(0);
  // const [neg, setNeg] = useState(0);
  const [loading, setLoading] = useState(false);
  const [listStatus, setListStatus] = useState([])
  const [list, setList] = useState([])
  const [listReal, setListReal] = useState([])
  const [formData, setFormData] = useState({})


  async function exec() {
    setLoading(true)
    const response = await axios.post("/case/invite-users");
    let lista = response.data
    let retorno = []
    let total = lista.length
    for (var i = 0; i < total; i++) {
      const empresas = lista[i].empresas.map((e, index) => ({
        corporateName: e['corporate_name'],
        cnpj: e['cnpj'],
        statusColor: e['status_color'],
        status: e['status'],
        attempts: e['attempts']
      }));
      lista[i]['empresas_li'] = empresas
      retorno.push(lista[i])
    }
    // console.log(retorno)
    setList(retorno)
    setListReal(retorno)
    setLoading(false)
  }

  async function exec_status() {
    // setLoading(true)
    const response = await axios.post("/case/all-status");
    setListStatus(response.data)
    // setLoading(false)
  }


  async function exec_filter() {
    console.log(formData)
    let key = (formData['fieldKey'] == undefined ? '' : formData['fieldKey'])
    let text = formData['fieldText']
    let status = formData['fieldStatus']

    if (text)
      text = text.toUpperCase()

    let array = listReal
    if (key != '') {
      switch (key) {
        case 'name':
          array = array.filter((v) => { return v[key].indexOf(text) != -1 })
          break;
        case 'corporate_name':
          array = array.filter((v) => {
            return (v['empresas'].filter((e) => {
              return e[key].indexOf(text) != -1
            })).length > 0
          })
          break;
        case 'cnpj':
          array = array.filter((v) => {
            return (v['empresas'].filter((e) => {
              return e[key].indexOf(text) != -1
            })).length > 0
          })
          break;
      }
    }
    if (status) {
      array = array.filter((v) => {
        return (v['empresas'].filter((e) => {
          return e['status'] == status
        })).length > 0
      })
    }
    setList(array)
  }


  const handleExport = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Metricas');

    worksheet.columns = [
      { header: 'Nome', key: 'name', width: 30 },
      { header: 'Abertura', key: 'open_count', width: 10 },
      { header: 'Visualização', key: 'click_count', width: 10 },
      { header: 'Recebeu?', key: 'received', width: 10 },
      { header: 'Acessou', key: 'many_access', width: 10 },
      { header: 'Empresa', key: 'empresa', width: 50 },
      { header: 'CNPJ', key: 'cnpj', width: 30 },
      { header: 'Status', key: 'status', width: 40 },
      { header: 'Ciclo', key: 'attempts', width: 10 }
    ];

    list.forEach(item => {
      const rowCount = item.empresas.length;
      item.empresas.forEach((empresa, index) => {
        worksheet.addRow({
          name: index === 0 ? item.name : '',
          open_count: index === 0 ? item.open_count : '',
          click_count: index === 0 ? item.click_count : '',
          received: index === 0 ? (item.received >= 1 ? 'Sim' : 'Não') : '',
          many_access: index === 0 ? item.many_access : '',
          empresa: empresa.corporate_name,
          cnpj: empresa.cnpj,
          status: empresa.status,
          attempts: empresa.attempts
        });

      });

      if (rowCount > 1) {
        const startRow = worksheet.rowCount - rowCount + 1;
        worksheet.mergeCells(startRow, 1, worksheet.rowCount, 1);
        worksheet.mergeCells(startRow, 2, worksheet.rowCount, 2);
        worksheet.mergeCells(startRow, 3, worksheet.rowCount, 3);
        worksheet.mergeCells(startRow, 4, worksheet.rowCount, 4);
        worksheet.mergeCells(startRow, 5, worksheet.rowCount, 5);
      }
    });

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'metricas.xlsx';
  
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }


  useEffect(() => {
    exec()
    exec_status()
    // exec3()
  }, []);

  return (
    <>
      <Container fluid className="case-new">
        <Header as='h1'>Relatório</Header>
        <Divider horizontal >
          <Header as='h4'>
            Métricas
          </Header>
        </Divider>
        <Segment>
          <Grid columns={4}>
            <GridColumn>
              <label>Campo de pesquisa</label>

              <select className="select-report" onChange={(e) => { setFormData({ ...formData, 'fieldKey': e.target.value }) }}>
                <option value=''>Selecione...</option>
                <option value='name'>Nome</option>
                <option value='corporate_name'>Nome da empresa</option>
                <option value='cnpj'>CNPJ</option>
              </select>
            </GridColumn>
            <GridColumn>
              <label>Status</label>
              <select className="select-report" onChange={(e) => { setFormData({ ...formData, 'fieldStatus': e.target.value }) }}>
                <option value=''>Selecione...</option>
                <option>Aguardando contato</option>
                <option>Negociando</option>
                <option>Aguardando assinaturas</option>
                <option>Concluido</option>
                <option>Arquivado</option>
                <option>Aguardando pagamento</option>
                <option>Aguardando assinatura e pagamento</option>
                <option>Encerrado</option>
              </select>

            </GridColumn>
            <GridColumn>
              <label>Valor para pesquisar</label>
              <input className="select-report" onChange={(e) => { setFormData({ ...formData, 'fieldText': e.target.value }) }} />
            </GridColumn>
            <GridColumn>
              <br />
              <Button onClick={(e) => {
                exec_filter();
              }} >Pesquisar</Button>
            <Button icon onClick={handleExport} style={{ background: 'none', border: 'none' }}>
              <i className="download icon"></i>
            </Button>
            </GridColumn>

          </Grid>
        </Segment>
        {/* {listStatus.map(s => {
          return (
            <Label as='a' color={s['tag_color']}>
              {s['description_system']}
            </Label>
          )
        })} */}
        <Segment loading={loading}>
          <Table celled>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Nome</Table.HeaderCell>
                <Table.HeaderCell>Abertura</Table.HeaderCell>
                <Table.HeaderCell>Visualização</Table.HeaderCell>
                <Table.HeaderCell>Recebeu?</Table.HeaderCell>
                <Table.HeaderCell>Acessou</Table.HeaderCell>
                <Table.HeaderCell>Empresa</Table.HeaderCell>
                <Table.HeaderCell>CNPJ</Table.HeaderCell>
                <Table.HeaderCell>Status</Table.HeaderCell>
                <Table.HeaderCell>Ciclo</Table.HeaderCell>
              </Table.Row>
            </Table.Header>

            <Table.Body>
              {list.map((r, index) => {
                const rowClass = index % 2 === 0 ? 'even-row' : 'odd-row';
                return (
                  <React.Fragment key={index}>
                    <Table.Row className={rowClass}>
                      <Table.Cell rowSpan={r.empresas_li.length}>{r['name']}</Table.Cell>
                      <Table.Cell rowSpan={r.empresas_li.length}>{r['open_count']}</Table.Cell>
                      <Table.Cell rowSpan={r.empresas_li.length}>{r['click_count']}</Table.Cell>
                      <Table.Cell rowSpan={r.empresas_li.length}>{r['received'] >= 1 ? "Sim" : "Não"}</Table.Cell>
                      <Table.Cell rowSpan={r.empresas_li.length}>{r['many_access']}</Table.Cell>
                      <Table.Cell>{r.empresas_li[0].corporateName}</Table.Cell>
                      <Table.Cell>{r.empresas_li[0].cnpj}</Table.Cell>
                      <Table.Cell>
                        <sup><Label size="" color={r.empresas_li[0].statusColor}>{r.empresas_li[0].status}</Label></sup>
                      </Table.Cell>
                      <Table.Cell>{r.empresas_li[0].attempts}</Table.Cell>
                    </Table.Row>
                    {r.empresas_li.slice(1).map((empresa, subIndex) => (
                      <Table.Row className={rowClass}>
                        <Table.Cell>{empresa.corporateName}</Table.Cell>
                        <Table.Cell>{empresa.cnpj}</Table.Cell>
                        <Table.Cell>
                          <sup><Label size="" color={empresa.statusColor}>{empresa.status}</Label></sup>
                        </Table.Cell>
                        <Table.Cell>{empresa.attempts}</Table.Cell>
                      </Table.Row>
                    ))}
                  </React.Fragment>
                );
              })}
            </Table.Body>
          </Table>
        </Segment>

      </Container>

    </>
  )
}

export default Reports;